export default {
	SHOULD_DELETE: "shouldDelete",
  inventory:{
    NONE: "none",
    CHECKED: "checked",
    TRANSFERRED: "transferred",
    TRANSFERRED_UNCHECKED: "transferred-unchecked",
  },
	CATEGORY_ID_WINE: 3,
	CATEGORY_ID_BEER: 2,
	CATEGORY_ID_SPIRIT: 4,
	CATEGORY_ID_NON_ALCOHOL: 1,

  // UPDATER:
  CAN_UPDATE_VENUEWINE: "canUpdateVenueWine",
  CAN_CREATE_VENUEWINE_WITH_WINE_ID: "canCreateVenueWineWithWineId",
  CAN_CREATE_WINE: "canCreateWine",
  CANNOT_CREATE: "cannotCreateVenueWine",

  IDENTIFIER_TO_VENUE_WINE_KEY: {
    'Artikelnummer': 'attributes.articleNumber',
    'Weingut': 'attributes.wine.data.attributes.winery.data.attributes.title',
    'Weinname': 'attributes.title',
    'Jahrgang': 'attributes.year',
    'Region': 'attributes.wine.data.attributes.region.data.attributes.title',
    'Land': 'attributes.wine.data.attributes.land.data.attributes.title',
    'Farbe': 'attributes.wine.data.attributes.wineType.data.attributes.title',
    'Rebsorte': 'attributes.wine.data.attributes.grapeVariety.data.attributes.title',
    'Flaschengröße': 'attributes.bottleSize.data.attributes.amount',
    'VK': 'attributes.sellingPrice',
    'Kommentar': 'attributes.comments',
    'Kategorie': 'attributes.wine.data.attributes.category.data.attributes.title',
    'VenueWine ID': 'id',
    'Wine ID': 'attributes.wine.data.id',
    'Preis': 'attributes.purchasePriceAvg',
  },


   IDENTIFIER_TO_SEARCH :{
    'Artikelnummer': 'articleNumber',
    'Weingut': 'winery',
    'Weinname': 'title',
    'Jahrgang': 'year',
    'Region': 'region',
    'Land': 'country',
    'Farbe': 'wineType',
    'Rebsorte': 'grapeVariety',
    'Flaschengröße': 'bottleSize',
    'VK': 'sellingPrice',
    'Kommentar': 'comments',
    'Preis': 'purchasePriceAvg',
   },

  VENUE_WINE_TARGET_MAPPING : {
        'Anzahl': 'amountFloat',
        'VK': 'sellingPrice',
        'Regal': 'shelfNumber',
        'Artikelnummer': 'articleNumber',
        'Kommentar': 'comments',
        'Kassennotiz': 'cashNote',
        'Bezugsquelle': 'purchasePrices',
  },
  DATE_TARGET: "Datum",
  DELETE_MODE: "delete",
  UPDATE_ADD_MODE: "update_add",
  UPDATE_REMOVE_MODE: "update_remove",
  OVERWRITE_MODE: "overwrite",
}